const SUBSCRIPTION = {
    ID: "abonnement",
    NAME: "serienavn",
    CLUB_CODE: "klubbkode",
    IMAGE: "kampanjebilde",
    EXTERNAL_DESCRIPTION: "ekstern-beskrivelse",
    CONCEPT: "konsept",
    DISTRIBUTION_DATES: {
        ID: "distribusjonsdatoer",
        SEND_DATE: "utsendelsesdato",
        CANCELLATION_DEADLINE: "avbestillingsfrist",
        PRODUCT: "produkt",
    },
    VARIANT: {
        OBLIGATIONS: {
            ID: "forpliktelser",
            MINIMUM_PURCHASE: "minimums-kjop",
            BINDING_PERIOD: "bindingstid",
        },
        FREIGHT: {
            ID: "frakt",
            INITIAL: "initial",
            RECURRING: "recurring",
        },
        GIFTS: {
            ID: "innmeldingsgaver",
            GIFTS: "gaver",
            COUNT: "antall",
        },
        CAN_BE_SOLD: "kanselges",
        CAN_BE_VISIBLE: "kanvises",
        VALUE_PROPOSITIONS: {
            ID: "valuepropositions",
            VALUE_PROPOSITION1: "valueproposition1",
            VALUE_PROPOSITION2: "valueproposition2",
            VALUE_PROPOSITION3: "valueproposition3",
        },
        TERMS: "vilkar",
        SHOW_BOOK_SELECTOR: "vis-bokvelger",
    },
};
export const SERIES = {
    SHAPE_ID: "serie",
    SERIES_ID: "serie-id",
    IMAGE: "bilde",
};
export const LITERARY_WORK = {
    SHAPE_ID: "verk",
    ID: "id",
    NAME: "navn",
    SUBTITLE: "undertittel",
    IMAGE: "bilde",
};
const SERIES_SUBSCRIPTION = {
    ID: "seriekampanje",
    NAME: "serienavn",
    CLUB_CODE: "klubbkode",
    IMAGE: "kampanjebilde",
    SERIES_DEFINITION: "seriedefinisjon",
    EXTERNAL_DESCRIPTION: "ekstern-beskrivelse",
    CONCEPT: "konsept",
    DISTRIBUTION_DATES: {
        ID: "distribusjonsdatoer",
        SEND_DATE: "utsendelsesdato",
    },
    VARIANT: {
        OBLIGATIONS: {
            ID: "forpliktelser",
            MINIMUM_PURCHASE: "minimums-kjop",
            BINDING_TIME: "bindingstid",
        },
        GIFTS: {
            ID: "innmeldingsgaver",
            GIFTS: "gaver",
            COUNT: "antall",
        },
        FREIGHT: {
            ID: "frakt",
            INITIAL: "initial",
            RECURRING: "recurring",
        },
        CAN_BE_SOLD: "kanselges",
        CAN_BE_VISIBLE: "kanvises",
        VALUE_PROPOSITIONS: {
            ID: "valuepropositions",
            VALUE_PROPOSITION1: "valueproposition1",
            VALUE_PROPOSITION2: "valueproposition2",
            VALUE_PROPOSITION3: "valueproposition3",
        },
        TERMS: "vilkar",
        SHOW_BOOK_SELECTOR: "vis-bokvelger",
        DEFAULT_PERIOD: "standard-intervall",
        CAMPAIGN_BOOKS: {
            ID: "innmeldingskampanje",
            BOOKS: "boker",
        },
    },
};
const BOOK_CLUB = {
    ID: "bokklubb",
    NAME: "serienavn",
    IS_CHILD_CLUB: "barneklubb",
    CLUB_CODE: "klubbkode",
    IMAGE: "bilde",
    EXTERNAL_DESCRIPTION: "ekstern-beskrivelse",
    CONCEPT: "konsept",
    FLOW: {
        ID: "flyt-klubb",
        NEXT_CLUB: "neste-klubb",
    },
    DISTRIBUTION_DATES: {
        ID: "distribusjonsdatoer",
        SEND_DATE: "utsendelsesdato",
        CANCELLATION_DEADLINE: "avbestillingsfrist",
        MEMBER_EXTRACTION_DATE: "medlemsuttrekksdato",
        PRICE: "pris",
        PRODUCT: "produkt",
        BATCH_CODE: "batchkode",
        BOOK_CLUB_PRODUCT_PIECE: "bokklubb-produkt",
        PRODUCTS_CHUNK: {
            ID: "produkter",
            PRODUCT: "produkt",
            OVERRIDDEN_PRICE: "overstyrt-pris",
        },
        // Editorial presentation of the main book or package on Min side
        PRESENTATION: {
            IMAGE: "presentasjonsbilde",
            LINK: "presentasjonslenke",
            TEXT: "presentasjonstekst",
            TITLE: "presentasjonstittel",
        },
    },
    // The member offers box on Min side
    /** Where a member goes to end the membership; a path or URL */
    CANCEL_LINK: "utmeldingslenke",
    MEMBER_OFFERS: {
        ID: "medlemstilbud",
        TITLE: "tittel",
        TEXT: "tekst",
        LINK: "lenke",
        LINK_TEXT: "lenketekst",
        IMAGE: "bilde",
    },
    TERMS_AND_CONDITIONS: {
        ID: "vilkar-og-forpliktelser",
        TERMS: "vilkar",
        OBLIGATIONS: {
            ID: "forpliktelser",
            BINDING_PERIOD: "bindingstid",
        },
    },
    VARIANT: {
        FREIGHT: {
            ID: "frakt",
            INITIAL: "initial",
            RECURRING: "recurring",
        },
        GIFTS: {
            ID: "innmeldingsgaver",
            GIFTS: "gaver",
            COUNT: "antall",
        },
        CAN_BE_SOLD: "kanselges",
        CAN_BE_VISIBLE: "kanvises",
        VALUE_PROPOSITIONS: {
            ID: "valuepropositions",
            VALUE_PROPOSITION1: "valueproposition1",
            VALUE_PROPOSITION2: "valueproposition2",
            VALUE_PROPOSITION3: "valueproposition3",
        },
        ENDING_INVOICE: {
            ID: "sluttfaktura",
            INVOICE_PRODUCT: "faktura-produkt",
            ALTERNATIVE_PRICE: "alternativ-pris",
        },
        BENEFITS: {
            ID: "verdiforslag-liste",
            BENEFIT: "verdiforslag",
        },
        TERMS: "vilkar",
        SHOW_BOOK_SELECTOR: "vis-bokvelger",
    },
};
const BOOK = {
    ID: "bok",
    ORIGINAL_TITLE: "originaltittel",
    IMPRINT: "imprint",
    VARIANT: {
        LANGUAGE: "sprak",
        SUBTITLE: "undertittel",
        SERIES_NAME: "serienavn",
        SERIES_ID: "serie-id",
        SERIES_NUMBER: "nummer-i-serie",
        LITERARY_WORK_ID: "verk-id",
        LITERARY_WORK_NAME: "verknavn",
        PAGEFLIPPER: "bla-i-boka",
        BINDING: "innbinding",
        PUBLISHER: "forlag",
        REVIEW: {
            ID: "anmeldelse",
            REVIEWER: "anmelder",
            TEXT: "tekst",
            SOURCE: "kilde",
            LINK: "lenke",
            LANGUAGE: "sprak",
            DICE_VALUE: "terningkast",
            DATE: "dato",
        },
        MENTION: {
            ID: "omtale",
            SOURCE: "kilde",
            LANGUAGE: "sprak",
            TEXT: "tekst",
        },
        CONTRIBUTORS: {
            ID: "bidragsyter",
        },
        PHYSICAL_MEASUREMENTS: {
            ID: "fysiske-mal",
            WEIGHT: "vekt",
            HEIGHT: "hoyde",
            WIDTH: "bredde",
            DEPTH: "dybde",
            NUMBER_OF_PAGES: "antall-sider",
        },
        DIGITAL_MEASUREMENTS: {
            ID: "digitale-mal",
            DURATION: "spilletid",
            FILE_FORMAT: "filformat",
            FILE_SIZE: "filstorrelse",
            COPY_PROTECTION: "kopibeskyttelse",
            SCREEN_ORIENTATION: "skjermretning",
            DEVICE_SUPPORT: "enhetsstotte",
            EBOOK_STANDARD: "ebok-standard",
            CONTENT: "innhold",
        },
        DDS_ID: "dds-id",
        SUBSCRIPTION_PUBLICATION_DATE: "lagerdato-abonnement",
        PUBLICATION_DATE: "utgivelsesdato",
        CAN_BE_SOLD: "kanselges",
        CAN_BE_VISIBLE: "kanvises",
        VAT_CHARGEABLE: "momsbelagt",
        STATUS_CODE: "statuskode",
        STATUS_MESSAGE: "statusmelding",
        ATTACHMENTS: "vedlegg",
        EXTRA_MATERIAL: "tilleggsmateriale",
        UTDANNING: {
            ID: "utdanning",
            ISALLVIT: "allvit",
            OPENACCESS_ID: "open-access-id",
            OPENACCESS_LISENSTYPE: "open-access-lisenstype",
            PEER_REVIEWED: "fagfellevurdert",
        },
        OFFER_PHYSICAL_EVALUATION_COPY: "tilby-fysisk-vurderingseksemplar",
        DIGITAL_EVALUATION_COPY_URL: "digital-vurderingseksemplar-lenke",
    },
};
const NOT_BOOK = {
    ID: "produkt",
    NOT_BOOK_TITLE: "ikke-bok-tittel",
    VARIANT: {
        TITLE: "tittel",
        SUBTITLE: "undertittel",
        EAN: "ean",
        DESCRIPTION: "omtale",
        CAN_BE_SOLD: "kanselges",
        CAN_BE_VISIBLE: "kanvises",
    },
};
const FREIGHT = {
    ID: "frakt",
    VARIANT: {
        EXTERNAL_DESCRIPTION: "ekstern-beskrivelse",
    },
};
const ENDING_INVOICE = {
    ID: "sluttfaktura",
    VARIANT: {
        EXTERNAL_DESCRIPTION: "ekstern-beskrivelse",
    },
};
const DIGITAL_SERVICE = {
    ID: "digital-tjeneste",
    ORGANIZATION_TYPE_FILTERING: "organisasjonstype-filtrering",
    VARIANT: {
        PRODUCT_TYPE: "produkttype",
        SUBTITLE: "undertittel",
        BINDING: "innbinding",
        LANGUAGE: "sprak",
        CONTRIBUTOR_STATEMENT: "forfattervisning",
        CONTRIBUTORS: "bidragsytere",
        PUBLICATION_DATE: "utgivelsesdato",
        PUBLISHER: "forlag",
        WEBSITE: "nettsted",
        WEBSITES: "nettsteder",
        DURATION: "varighet",
        MENTION: "omtale",
        LIMITED: "begrenset",
        VERK_NAME: "verknavn",
        VERK_ID: "verk-id",
        VERK: "verk",
        CONTRIBUTOR: {
            AUTHOR: "forfatter",
            ILLUSTRATOR: "illustrator",
            TRANSLATOR: "oversetter",
            NARRATOR: "innleser",
            CONTRIBUTIONS_BY: "bidrag-av",
            NOTES_BY: "notetegner",
            CREATED_BY: "skapt-av",
            RETOLD_BY: "gjenfortalt-av",
            EDITED_BY: "redigert-av",
            COMPOSED_BY: "komponert-av",
            PHOTOGRAPHED_BY: "foto-av",
            COVER_DESIGN_OR_ARTWORK_BY: "omslagsillustrator",
            UNKNOWN: "ukjent",
        },
    },
};
const PRODUCT = {
    ID: "product",
    SUBSCRIPTION,
    SERIES_SUBSCRIPTION,
    BOOK_CLUB,
    DIGITAL_SERVICE,
    BOOK,
    NOT_BOOK,
    FREIGHT,
    PRODUCT_BUNDLE: {
        SHAPE_ID: "produktpakke",
        NAME: "navn",
        CAN_BE_SOLD: "kanselges",
        CAN_BE_VISIBLE: "kanvises",
        STATUS_CODE: "statuskode",
        STATUS_MESSAGE: "statusmelding",
        DESCRIPTION: "beskrivelse",
        PRODUCTS: "produkter",
    },
};
const CONTRIBUTOR = {
    ID: "bidragsyter",
    SCID: "scid",
    FIRST_NAME: "fornavn",
    SURNAME: "etternavn",
    YEAR_OF_BIRTH: "fodselsar",
    YEAR_OF_DEATH: "dodsar",
    IMAGE: "bilde",
    BIOGRAPHY: "biografi",
    CONTRIBUTOR_LINKS: {
        ID: "forfatterlenker",
        LINK_TEXT: "navn",
        URL: "lenke",
    },
};
const SERIES_DEFINITION = {
    ID: "seriedefinisjon",
    SERIES_BOOKS: "boker-i-serien",
    SERIES_STATUS: "status",
    BOOKS: {
        ID: "boker",
        BOOK: "bok",
        NUMBER_IN_SERIES: "nummer-i-serien",
    },
    BINDING: "innbinding",
    SPARTA_ID: "spartaid",
};
const PACK = {
    ID: "pakke",
    PRODUCTS: "produkter",
    EXTERNAL_DESCRIPTION: "ekstern-beskrivelse",
};
const PRODUCT_LIST = {
    ID: "produktliste",
    PRODUCTS: "produkter",
};
const CONCEPT = {
    NAME: "navn",
    LOGO: "logo",
};
const DOCUMENT = {
    ID: "document",
    CONTRIBUTOR: CONTRIBUTOR,
    LITERARY_WORK: LITERARY_WORK,
    SERIES: SERIES,
    SERIES_DEFINITION: SERIES_DEFINITION,
    PACK: PACK,
    PRODUCT_LIST: PRODUCT_LIST,
    CONCEPT: CONCEPT,
};
export const CRYSTALLIZE_IDS = {
    SHAPE: {
        PRODUCT: PRODUCT,
        DOCUMENT: DOCUMENT,
    },
    PRICING: {
        PRICE: "default",
    },
    // Subscription plan identifiers differ from shape identifiers in some cases
    SUBSCRIPTION_PLAN_IDENTIFIER: {
        SUBSCRIPTION: "abonnement",
        SERIES_SUBSCRIPTION: "serieabonnement",
        DIGITAL_SUBSCRIPTION: "digitalt-abonnement",
    },
};
export const SERIES_DEFINITION_STATUS_VALUES = {
    ONGOING: "pågående",
    FINISHED: "avsluttet",
};
export const DIGITAL_SERVICES = {
    MANUAL_OVERRIDE_RESTRICTED_ACCESS: "manuell-overstyring-begrenset-tilgang",
};
